"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.usePaginationContext = exports.PaginationProvider = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../utils");
const PaginationContext = (0, react_1.createContext)(null);
const range = (start, end) => Array.from({ length: end - start + 1 }, (_, idx) => idx + start);
const getPaginationRange = (totalCount, pageSize, siblingCount, currentPage) => {
    const DOTS = "...";
    const totalPageCount = Math.ceil(totalCount / pageSize);
    const totalPageNumbers = siblingCount + 5;
    if (totalPageNumbers >= totalPageCount) {
        return range(1, totalPageCount);
    }
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;
    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    if (!shouldShowLeftDots && shouldShowRightDots) {
        return [...range(1, 3 + siblingCount), DOTS, totalPageCount];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
        return [firstPageIndex, DOTS, ...range(totalPageCount - (3 + siblingCount) + 1, totalPageCount)];
    }
    if (shouldShowLeftDots && shouldShowRightDots) {
        return [firstPageIndex, DOTS, ...range(leftSiblingIndex, rightSiblingIndex), DOTS, lastPageIndex];
    }
    return [];
};
const PaginationProvider = ({ children, totalCount, pageSize, currentPage = 1, siblingCount = 1, onPageChange, }) => {
    const [activePage, setActivePage] = (0, react_1.useState)(currentPage);
    const paginationRange = (0, react_1.useMemo)(() => getPaginationRange(totalCount, pageSize, siblingCount, activePage), [totalCount, pageSize, siblingCount, activePage]);
    const lastPage = Math.ceil(totalCount / pageSize);
    const handlePageChange = (page) => {
        if (page !== activePage && page >= 1 && page <= lastPage) {
            setActivePage(page);
            onPageChange(page);
        }
    };
    const contextValue = {
        paginationRange,
        lastPage,
        activePage,
        handlePageChange,
    };
    return (react_1.default.createElement(PaginationContext.Provider, { value: contextValue }, children));
};
exports.PaginationProvider = PaginationProvider;
const usePaginationContext = () => {
    const context = (0, react_1.useContext)(PaginationContext);
    if (!context) {
        throw new Error("usePaginationContext must be used within a PaginationProvider");
    }
    return context;
};
exports.usePaginationContext = usePaginationContext;
const Pagination = ({ prevText = "Prev", nextText = "Next", className = "", }) => {
    const { paginationRange, lastPage, activePage, handlePageChange } = (0, exports.usePaginationContext)();
    const handlePageClick = (page) => {
        if (typeof page === "number") {
            handlePageChange(page);
        }
    };
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(`flex justify-center items-center mt-4 ${className}`) },
        react_1.default.createElement("ul", { className: "flex space-x-2" },
            react_1.default.createElement("li", { className: `px-4 py-2 border rounded-md cursor-pointer ${activePage === 1 ? "opacity-50 cursor-not-allowed" : ""}`, onClick: () => activePage > 1 && handlePageClick(activePage - 1) }, prevText),
            paginationRange.map((page, index) => page === "..." ? (react_1.default.createElement("li", { key: `dots-${index}`, className: "px-3 py-2 text-grey500 border rounded-md cursor-default" }, "...")) : (react_1.default.createElement("li", { key: page, className: `px-4 py-2 border rounded-md cursor-pointer ${page === activePage ? "active bg-blue-500 text-brandWhite" : "hover:bg-grey100"}`, onClick: () => handlePageClick(page) }, page))),
            react_1.default.createElement("li", { className: `px-4 py-2 border rounded-md cursor-pointer ${activePage === lastPage ? "opacity-50 cursor-not-allowed" : ""}`, onClick: () => activePage < lastPage && handlePageClick(activePage + 1) }, nextText))));
};
exports.Pagination = Pagination;
